export default "__VITE_ASSET__D0BzdNrI__"